import moment from "moment";

import { Recall } from "@/Common/Api/Communications/Dto/Recall";
import { ArrayHelper } from "@/Common/Helpers/ArrayHelper";
import * as ServerOperations from "@/Common/Operations/operations.server";
import * as SubServerOperations from "@/Common/Operations/operations.server.sub";
import { BaseAction } from "@/Common/Stores/Actions/BaseAction";
import { GlobalSendCommunicationStore } from "@/Communications/Stores/GlobalSendCommunicationStore";

class SendRecallAction extends BaseAction {
    public CreateRecall(store: GlobalSendCommunicationStore, isSentFromEncounter: boolean = false, encounterId: string = null): void {
        var recall = new Recall();

        recall.DueDate = (store.SendRecallPopupModel.get("DueDate") == null) ? null : moment(store.SendRecallPopupModel.get("DueDate")).format("YYYY-MM-DD");
        recall.Type = store.SendRecallPopupModel.get("DescriptionText");
        recall.IsCompleted = false;
        recall.SpecializationLookupId = store.SendRecallPopupModel.get("SelectedSpecializationId");
        recall.PriorityLookupId = store.SendRecallPopupModel.get("SelectedPriorityId");
        recall.Notes = store.SendRecallPopupModel.get("Notes");

        var clinicianGroups = store.SendRecallPopupModel.get("SelectedClinicians").toArray().filter(x => x.IsPersonGroup);
        var clinicianIds = store.SendRecallPopupModel.get("SelectedClinicians").toArray().map(x => x.ContactId);
        var patientIds = store.SendRecallPopupModel.get("SelectedPatients").toArray().map(x => x.ContactId);

        // get clinicians in group
        clinicianGroups.forEach(x => {
            if (x.GroupEmployeeModels && x.GroupEmployeeModels.length > 0) {
                x.GroupEmployeeModels.forEach(ge => {
                    // shit-horse!
                    var person = cacheStore.GetCliniciansPersonsByContactFacetId(ge);
                    clinicianIds.push(person.ContactId);
                });
            }

            var idx = clinicianIds.indexOf(x.ContactId);
            clinicianIds.splice(idx, 1);
        });

        // ensure clinicians in groups are not in list twice
        clinicianIds = ArrayHelper.Unique(clinicianIds);

        var requestData = {
            Recall: recall,
            PatientIds: patientIds,
            PracticiansIds: clinicianIds,
            IsSentFromEncounter: isSentFromEncounter,
            EncounterId: encounterId
        };

        this.Execute(ServerOperations.Server.Myle_UpsertRecall, requestData, SubServerOperations.Recalls.SaveFromPopup);
    }
}

export { SendRecallAction };
